var native = {};

export { native as __exports };
//# sourceMappingURL=native.js.map
